// Centralized fetch wrapper: sends cookies, injects the active organization header,
// and notifies a registered handler on 401 so the app can drop to the login screen.

let activeOrganizationId: number | null = null;
let unauthorizedHandler: (() => void) | null = null;

export function setApiOrganizationId(id: number | null) {
  activeOrganizationId = id;
}

export function setUnauthorizedHandler(fn: (() => void) | null) {
  unauthorizedHandler = fn;
}

export async function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers || {});
  if (activeOrganizationId != null) {
    headers.set("X-Organization-Id", String(activeOrganizationId));
  }
  const response = await fetch(input, {
    ...init,
    credentials: "include",
    headers,
  });
  if (response.status === 401) {
    unauthorizedHandler?.();
  }
  return response;
}

export async function apiJson<T = any>(input: string, init: RequestInit = {}): Promise<T> {
  const response = await apiFetch(input, init);
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error((data && data.error) || "Request failed");
  }
  return data as T;
}

export function apiPostJson<T = any>(input: string, body: unknown): Promise<T> {
  return apiJson<T>(input, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}
